import React from 'react';
import { Link } from 'react-router-dom';
import { MailIcon, MapPinIcon } from 'lucide-react';
import { profile } from '../data/profile';
import { sections } from '../data/sections';
export function SiteFooter() {
  return <footer className="border-t border-white/10 bg-navy-950 py-14" aria-label="Site footer" data-id="element-98" data-mp="3mg86610ozsx9">
      <div className="mx-auto grid w-full max-w-7xl grid-cols-1 gap-12 px-6 lg:grid-cols-12 lg:px-10" data-id="element-99" data-mp="3hhet29pbi3xm">
        <div className="lg:col-span-5" data-id="element-100" data-mp="3dhmf1hh5n5kv">
          <p className="font-display text-sm font-bold uppercase tracking-[0.2em] text-white" data-id="element-101" data-mp="3dei3u059v9kp">
            {profile.name}
          </p>
          <p className="mt-4 max-w-sm font-sans text-sm leading-relaxed text-platinum-300" data-id="element-102" data-mp="33hvizbcy4iio">
            {profile.title}
          </p>
          <ul className="mt-6 space-y-2.5" data-id="element-103" data-mp="2yl560wwfu31h">
            <li className="flex items-center gap-3" data-id="element-104" data-mp="11r1z4bvxdf4v">
              <MailIcon className="h-4 w-4 shrink-0 text-gold-400" aria-hidden="true" data-id="element-105" data-mp="11qs9ipesl9zp" />
              <a href={`mailto:${profile.email}`} className="font-sans text-sm text-platinum-200 transition-colors duration-150 ease-out hover:text-gold-400" data-id="element-106" data-mp="wtijp8nhqwbc">
                {profile.email}
              </a>
            </li>
            <li className="flex items-center gap-3" data-id="element-107" data-mp="vt7g6hr3vq0q">
              <MapPinIcon className="h-4 w-4 shrink-0 text-gold-400" aria-hidden="true" data-id="element-108" data-mp="vus962xrv0wh" />
              <span className="font-sans text-sm text-platinum-200" data-id="element-109" data-mp="10s0qk1b3j0wo">{profile.location}</span>
            </li>
          </ul>
        </div>

        <div className="lg:col-span-7" data-id="element-110" data-mp="1tg6eewxg560q">
          <p className="font-sans text-xs font-semibold uppercase tracking-[0.18em] text-platinum-300" data-id="element-111" data-mp="1tf4qvsz8ur24">
            All sections
          </p>
          <ul className="mt-5 grid grid-cols-1 gap-x-8 gap-y-2.5 sm:grid-cols-2" data-id="element-112" data-mp="1eppa95tfg205">
            <li data-id="element-113" data-mp="1jojumc71lymd">
              <Link to="/" className="flex items-baseline gap-3 font-sans text-sm text-platinum-200 transition-colors duration-150 ease-out hover:text-gold-400" data-id="element-114" data-mp="27g7eia5w09f5">
                <span className="font-display text-xs font-bold text-gold-500" data-id="element-115" data-mp="2m2nysdgjn576">00</span>
                <span data-id="element-116" data-mp="2h3thxh24zqpp">Introduction</span>
              </Link>
            </li>
            {sections.map(section => <li key={section.path} data-id="element-117" data-mp="2d1q3cjk68607">
                <Link to={section.path} className="flex items-baseline gap-3 font-sans text-sm text-platinum-200 transition-colors duration-150 ease-out hover:text-gold-400" data-id="element-118" data-mp="2d0of1de59n0j">
                  <span className="font-display text-xs font-bold text-gold-500" data-id="element-119" data-mp="235wjef44ha8e">{section.number}</span>
                  <span data-id="element-120" data-mp="1ybihruyva6va">{section.name}</span>
                </Link>
              </li>)}
          </ul>
        </div>
      </div>

      <div className="mx-auto mt-12 w-full max-w-7xl border-t border-white/10 px-6 pt-8 lg:px-10" data-id="element-121" data-mp="1pdgd95fxcw39">
        <p className="font-sans text-xs text-platinum-300" data-id="element-122" data-mp="1kdtyusod19sv">
          Analytics, Data &amp; AI Governance · Melbourne, Victoria
        </p>
      </div>
    </footer>;
}